import { Box, Grid } from "@mui/material";
import { Assignment } from "../../api";
import { useSuspendGradingScope } from "../../hooks/use-suspend-grading-scope";
import { ResizableDrawer } from "../common/ResizableDrawer";
import AssignmentConfigPanel from "./AssignmentConfigPanel";

const AssignmentViewModal = ({
	assignment,
	assignments,
	open,
	onSave,
	onClose,
	id,
	tabQueryParam,
}: {
	assignment: Assignment;
	assignments: Assignment[];
	open: boolean;
	onSave: (assignment: Assignment) => Promise<Assignment>;
	onClose: () => void;
	id?: string;
	tabQueryParam?: string;
}) => {
	useSuspendGradingScope(open);
	return (
		<ResizableDrawer
			id={`${id}-drawer`}
			open={open}
			onClose={onClose}
			dataComponent="assignment-view-modal"
			label="Role"
		>
			<Box>
				<Grid
					id={`${id}-grid`}
					container
					sx={{ padding: (theme) => theme.spacing(2) }}
					height="100%"
					spacing={2}
				>
					<Grid size={12}>
						<AssignmentConfigPanel
							id={id}
							assignment={assignment}
							assignments={assignments}
							onSave={onSave}
							tabQueryParam={tabQueryParam}
						/>
					</Grid>
				</Grid>
			</Box>
		</ResizableDrawer>
	);
};

export default AssignmentViewModal;
